import React from 'react'

import animation from '../assets/lottie/ob.json'
import Lottie from 'react-lottie-player'

export default function LoadingLottie() {
  return (
    <div>
      <Lottie
        loop
        play
        animationData={animation}
        style={{
          width: '50vh',
          height: '50vh',
        }}
      />
    </div>
  )
}
